import React from 'react';
import { Link } from 'react-router-dom';
import backgroundImage from '../../assets/img/fondoTres.png';
import logoCIE from '../../assets/img/logoCIE.svg';
import arrowLeft from '../../assets/img/arrowLeft.png';
import HeaderUsuario from '../header/HeaderUsuario';
import useResultados from '../../hooks/useResultados';

const ResultadosUsuario = () => {
  // Hook personalizado para obtener los resultados del usuario
  const { resumen, cargando, error, aprobado } = useResultados();

  // Renderiza un mensaje de carga mientras se obtienen los resultados
  if (cargando) {
    return <div className="min-h-screen flex justify-center items-center">Cargando resultados...</div>;
  }

  // Renderiza un mensaje de error si ocurre algún problema
  if (error) {
    return <div className="min-h-screen flex justify-center items-center text-red-600">{error}</div>;
  }

  // Componente principal que renderiza la página de resultados del usuario
  return (
    <div className="min-h-screen flex flex-col font-montserrat"
      style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      {/* Header del usuario */}
      <div className="absolute top-4 right-4 z-10">
        <HeaderUsuario />
      </div>

      {/* Contenido principal */}
      <div className="flex-grow flex justify-center items-center">
        <div className="bg-white rounded-lg p-8 shadow-lg max-w-2xl w-full relative">
          {/* Enlace a la página de trofeos si el usuario aprobó */}
          {aprobado && (
            <Link to="/trofeo-usuario" className="absolute top-3 right-3 bg-[#15A054] rounded-full w-10 h-10 flex items-center justify-center">
              <img src={arrowLeft} alt="Ir a Trofeos" className="w-6 h-6" />
            </Link>
          )}

          <h2 className="text-5xl font-montserrat font-extrabold mb-6 text-green-700 text-center">Resultados</h2>
          <p className="text-center text-4xl font-bold mb-4 text-gray-500">{resumen.resumen}</p>

          {/* Visualización de resultados */}
          <div className="flex justify-center items-center space-x-8 mb-6">
            {/* Respuestas correctas */}
            <div className="flex flex-col items-center">
              <div className="bg-[#15A054] rounded-full w-20 h-20 flex items-center justify-center mb-2">
                <span className="text-white font-bold text-2xl">{resumen.total_correctas}</span>
              </div>
              <span className="text-[#15A054] font-bold">Aciertos</span>
            </div>
            {/* Respuestas incorrectas */}
            <div className="flex flex-col items-center">
              <div className="bg-[#E94E2D] rounded-full w-20 h-20 flex items-center justify-center mb-2">
                <span className="text-white font-bold text-2xl">{resumen.total_incorrectas}</span>
              </div>
              <span className="text-[#E94E2D] font-bold">Con ajustes</span>
            </div>
          </div>
          
          {/* Mensaje de no aprobación si el usuario no aprobó */}
          {!aprobado && (
            <div className="text-center mt-6">
              <span className="text-red-500 font-bold text-xl">NO APROBASTE</span>
            </div>
          )}
        </div>
      </div>

      {/* Logo CIE */}
      <div className="absolute bottom-8 right-8">
        <img src={logoCIE} alt="Logo CIE" className="h-auto w-auto" />
      </div>
    </div>
  );
};

export default ResultadosUsuario;